<template>
  <v-row justify="center" align="center">
    <v-col cols="11" md="8" lg="4">
      <h1 class="mb-5">Reset your password</h1>
      <p class="pb-5">
        An email will be sent to your registered email address with instructions
        on how to reset your password
      </p>

      <v-text-field solo v-model="email" placeholder="Email"></v-text-field>

      <p :class="getClass()">{{ message }}</p>
      <v-row justify="center">
        <v-btn
          class="primary"
          :loading="loading"
          :disabled="success"
          @click="sendResetEmail"
          >Submit</v-btn
        >
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import {
  fetchSignInMethod,
  sendResetPasswordEmail,
} from "@/util/auth/auth";
export default {
  data() {
    return {
      email: "",
      loading: false,
      success: false,
      message: "",
    };
  },
  methods: {
    getClass() {
      if (this.success) {
        return "text-center success--text";
      } else {
        return "text-center error--text";
      }
    },
    async isPasswordSignInMethod() {
      const signInMethod = await fetchSignInMethod(this.email);
      if (signInMethod !== "password") {
        this.message = `Please login with ${signInMethod} instead`;
        return false;
      }
      return true;
    },
    async sendResetEmail() {
      if (this.email == "") {
        this.message = "Please enter an email";
        return;
      }
      this.loading = true;
      this.success = false;
      this.message = "";
      try {
        await sendResetPasswordEmail(this.email);
        this.success = true;
        this.message = "An email to reset your password has been sent!";
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    handleError() {
      this.loading = false;
    },
  },
};
</script>